<template>

    <section id="not-found" class="v-center text-center  mt-5">
        <div>
            <div>
                <h1 class="display-4">404 - Page Not Found</h1>
                <p class="lead">Sorry, the page you are looking for does not exist.</p>
                <a class="btn btn-primary" :href="'site_br_root' | cr">Go to Main Site</a>
                <!-- <span>{{ 'site_br_root' | cr }}</span> -->
                <!-- <span>{{ mainSite | cr }}</span> -->
            </div>
        </div>
    </section>

</template>

<script>
import { publicWebURI } from '@/apiConfig'
export default {
    name: 'NotFound',
    props: {
        mainSite: {
            type: String,
            default: () => publicWebURI
        }
    },
    mounted() {
        document.title = '404 - Page Not Found';
        if (window.mainUI && typeof window.mainUI === 'function')
            window.mainUI();
    },
}
</script>

<style lang="scss">
#not-found {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
</style>